import { render, staticRenderFns } from "./WarehouseEdit.vue?vue&type=template&id=06bbd4f6&"
import script from "./WarehouseEdit.vue?vue&type=script&lang=js&"
export * from "./WarehouseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports